import { FeatureToggleClientService } from 'feature-toggle-client';
const actionCondition = 'action-with-condition';
const actionSurvey = 'action-with-survey';
const actionProcessContentAssistant = 'action-process-content-assistant';
const actionExecuteTemplate = 'builder-execute-template-action';
const actionExecuteScriptV2 = 'builder-execute-script-v2-action';
const actionExecuteBlipFunction = 'builder-function-library-action';
const contactTaxDocument = 'contact-tax-document';
const analyticsHidingEventTrackLabelandValue = 'analytics-is-hiding-event-track-label-and-value-blip-portal';
const configurationsApplicationsDomainUsageGet = 'use-configurations-domain-on-misc-operations-get';
const configurationsApplicationsDomainUsageSet = 'use-configurations-domain-on-misc-operations-set';
export class ActionFeatures {
    static isActionConditionEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(actionCondition);
    }
    static isActionSurveyEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(actionSurvey);
    }
    static isActionProcessContentAssistantEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(actionProcessContentAssistant);
    }
    static isActionExecuteTemplateEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(actionExecuteTemplate);
    }
    static isActionExecuteScriptV2Enabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(actionExecuteScriptV2);
    }
    static isContactTaxDocumentEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(contactTaxDocument);
    }
    static analyticsHidingLabelandValueEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(analyticsHidingEventTrackLabelandValue);
    }
    static isUseConfigurationsDomainOnMiscOperationsGetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(configurationsApplicationsDomainUsageGet, false);
    }
    static isUseConfigurationsDomainOnMiscOperationsSetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(configurationsApplicationsDomainUsageSet, false);
    }
    static isActionExecuteBlipFunction() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(actionExecuteBlipFunction);
    }
}
